import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";
import { SectionHeading, reveal } from "@/components/Section";

export default function Manifesto() {
  const { t } = useLanguage();
  return (
    <section id="manifesto" className="relative py-28 sm:py-36" data-testid="manifesto-section">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <SectionHeading
              eyebrow={t.manifesto.eyebrow}
              title={t.manifesto.title}
              sub={t.manifesto.intro}
            />
            <motion.p {...reveal} className="font-display text-stroke-sand font-black uppercase text-[6rem] sm:text-[8rem] leading-none hidden lg:block">
              MNFST
            </motion.p>
          </div>
        </div>

        <div className="lg:col-span-7 flex flex-col">
          {t.manifesto.chapters.map((ch, i) => (
            <motion.div
              key={ch.num}
              data-testid={`manifesto-chapter-tab-${ch.num}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group relative border-t border-line py-10 sm:py-12 last:border-b hover:bg-surface/50 transition-colors duration-300 px-2 sm:px-4"
            >
              <div className="absolute left-0 top-0 h-full w-[3px] bg-blaze scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-500" />
              <div className="flex items-start gap-6 sm:gap-10">
                <span className="font-telemetry text-stroke-blaze text-5xl sm:text-7xl font-bold leading-none shrink-0 w-16 sm:w-24">
                  {ch.num}
                </span>
                <div>
                  <h3 className="font-display text-2xl sm:text-4xl font-extrabold uppercase tracking-tight text-bone group-hover:text-blaze transition-colors duration-300">
                    {ch.title}
                  </h3>
                  <p className="mt-3 text-sm sm:text-base leading-relaxed text-ash max-w-xl">
                    {ch.text}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
